import { render, staticRenderFns } from "./EconomicGroupForm.vue?vue&type=template&id=e1c628a6"
import script from "./EconomicGroupForm.vue?vue&type=script&lang=js"
export * from "./EconomicGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports